import { render, staticRenderFns } from "./BankAccountCreateUpdate.vue?vue&type=template&id=418f9fc5&scoped=true&"
import script from "./BankAccountCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./BankAccountCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./BankAccountCreateUpdate.vue?vue&type=style&index=0&id=418f9fc5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418f9fc5",
  null
  
)

export default component.exports